<script></script>

<template>
  <div class="bottom">
    <a href="https://openolainfarm.uz/" target="_blank" rel="noopener noreferrer">
      <img
        class="bottom__logo"
        src="@/assets/img/ui/bottom/logo.svg"
        alt="logo-olainFarm"
      />
    </a>
    <p class="bottom__copy">© Copyright 2024 OlainFarm</p>
  </div>
</template>

<style scoped lang="scss">
.bottom {
  display: flex;
  justify-content: space-between;
  align-items: end;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 20px 60px;
  height: 100px;

  @media screen and (max-width: 1024px) {
    padding: 20px;
  }

  &__logo {
    width: 61px;
    height: auto;
    display: block;
  }

  &__copy {
    color: var(--Green_1, #42ad76);
    font-variant-numeric: lining-nums proportional-nums;
    font-family: "MetaPro", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  }
}
</style>
